import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    alert('Thank you for your inquiry! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      company: '',
      subject: '',
      message: ''
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div>
      {/* Header Section */}
      <section className="bg-gray-900 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">Contact Us</h1>
          <p className="text-xl text-gray-300">Get in touch with our expert team</p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
            {/* Contact Information */}
            <div>
              <h2 className="text-3xl font-bold mb-8 section-title">Get In Touch</h2>
              <p className="text-lg text-gray-700 mb-8">
                We're here to help you with all your process equipment needs. Reach out to our team for consultations, quotes, or any inquiries.
              </p>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="text-accent text-2xl">📍</div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1">Location</h3>
                    <p className="text-gray-600">Palwal, Haryana, India</p>
                    <p className="text-gray-600">Delhi-Mathura Highway</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="text-accent text-2xl">📞</div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1">Phone</h3>
                    <p className="text-gray-600">+91 [Your Phone Number]</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="text-accent text-2xl">✉️</div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1">Email</h3>
                    <p className="text-gray-600">info@athenaprocess.com</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="text-accent text-2xl">🕒</div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1">Business Hours</h3>
                    <p className="text-gray-600">Monday - Saturday: 9:00 AM - 6:00 PM</p>
                    <p className="text-gray-600">Sunday: Closed</p>
                  </div>
                </div>
              </div>

              <div className="mt-12 p-6 bg-gray-50 rounded-lg">
                <h3 className="font-bold text-xl mb-3 text-green">Why Choose Athena?</h3>
                <ul className="space-y-2 feature-list">
                  <li className="text-gray-700">24+ years of leadership experience</li>
                  <li className="text-gray-700">ISO 9001:2015 & ISO 14001:2015 Certified</li>
                  <li className="text-gray-700">End-to-end turnkey solutions</li>
                  <li className="text-gray-700">High energy efficient equipment</li>
                  <li className="text-gray-700">Experienced engineering team</li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <div className="bg-gray-50 p-8 rounded-lg">
                <h2 className="text-2xl font-bold mb-6">Send Us A Message</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-semibold mb-2" htmlFor="name">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-accent"
                      placeholder="Your Name"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-2" htmlFor="email">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-accent"
                      placeholder="your@email.com"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-2" htmlFor="phone">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-accent"
                      placeholder="+91 XXXXXXXXXX"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-2" htmlFor="company">
                      Company Name
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-accent"
                      placeholder="Your Company"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-2" htmlFor="subject">
                      Subject *
                    </label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-accent"
                    >
                      <option value="">Select a subject</option>
                      <option value="quote">Request a Quote</option>
                      <option value="project">Project Inquiry</option>
                      <option value="equipment">Equipment Information</option>
                      <option value="support">Technical Support</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-2" htmlFor="message">
                      Message *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-accent"
                      placeholder="Tell us about your requirements..."
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="w-full btn-primary py-3 rounded-lg font-semibold text-lg"
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map or Additional Info Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6 section-title inline-block">Our Manufacturing Unit</h2>
            <p className="text-lg text-gray-700 mt-8 mb-8">
              Located at Palwal, Haryana state along the Delhi-Mathura Highway, our manufacturing facility benefits from excellent infrastructure and access to skilled manpower. The strategic location ensures efficient logistics and timely project delivery.
            </p>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-lg card-hover">
                <div className="text-4xl mb-3 text-accent">🏭</div>
                <h3 className="font-bold text-lg mb-2">Modern Facility</h3>
                <p className="text-gray-600 text-sm">State-of-the-art manufacturing setup</p>
              </div>
              <div className="bg-white p-6 rounded-lg card-hover">
                <div className="text-4xl mb-3 text-green">👷</div>
                <h3 className="font-bold text-lg mb-2">Skilled Workforce</h3>
                <p className="text-gray-600 text-sm">Experienced and trained professionals</p>
              </div>
              <div className="bg-white p-6 rounded-lg card-hover">
                <div className="text-4xl mb-3 text-accent">📍</div>
                <h3 className="font-bold text-lg mb-2">Strategic Location</h3>
                <p className="text-gray-600 text-sm">Easy access via Delhi-Mathura Highway</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;